import React, {useState, useEffect, useContext} from 'react'
import '../App.scss'
import axios from "axios";
import ImageBox from "./Image";
import ImageModal from "./ImageModal";
import ReactModal from 'react-modal';
import AllTripsMap from "./AllTripsMap";
import {confirmAlert} from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import nflTeams from "./utils/nflTeams";
import {heicTo} from "heic-to"
import {convertCamelCaseToSpacedWords, formatDate, getBearerToken, getServerUrl, userIsMobile} from "./utils/utils";
import ImageLoaderModal from "./ImageLoaderModal";
import {UserContext} from "./UserContext";
import TagFriendsModal from "../TagFriendsModal";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import {nationalParks} from "./utils/NationalParksUtils";
import {accessToken} from "./tokens";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import CircularProgress from '@mui/material/CircularProgress/';
import Box from "@mui/material/Box";
import CircularProgressWithLabel from "./utils/CircularProgressWithLabel";
import LinearProgress from "@mui/material/LinearProgress";
import {useParams} from "react-router-dom";
import {FormControl, MenuItem, Select} from "@mui/material";
import CreateActivity from "./CreateActivity";
import mlbTeams from "./utils/mlbTeams";

function ViewTrip({open, selectedTripId, onClose, onTripUpdate, startEditingTrip = false}) {
    const {id} = useParams()
    const {user, allTrips} = useContext(UserContext)
    const tripId = selectedTripId || window.location.pathname.split("/")[2];
    const [name, setName] = useState('');
    const [location, setLocation] = useState('')
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('')
    const [images, setImages] = useState([])
    const [allImages, setAllImages] = useState([])
    const [modalImage, setModalImage] = useState(null)
    const [openImageModal, setOpenImageModal] = useState(false)
    const [tripType, setTripType] = useState("single");
    const [parentTripName, setParentTripName] = useState('')
    const [parentTrips, setParentTrips] = useState([])
    const [userCategories, setUserCategories] = useState([])
    const [tripActivities, setTripActivities] = useState([])
    const [taggedUsers, setTaggedUsers] = useState([])
    const [tripOwnerId, setTripOwnerId] = useState(null)
    const [openAddActivitiesModal, setOpenAddActivitiesModal] = useState(false)
    const [activityIdForImages, setActivityIdForImages] = useState(null)
    const [imageIdsForActivity, setImageIdsForActivity] = useState([])
    const [locationsClickedStatus, setLocationsClickedStatus] = useState({})
    const [childTrips, setChildTrips] = useState(null)
    const [parentTripSelected, setParentTripSelected] = useState(false)
    const [parentTripImages, setParentTripImages] = useState({})
    const [selectedChildTrip, setSelectedChildTrip] = useState(tripId)
    const [editingTrip, setEditingTrip] = useState(startEditingTrip)
    const [currentSelectedTripId, setTripId] = useState(tripId)
    const [category, setCategory] = useState("")
    const [customCategory, setCustomCategory] = useState("")
    const [categoryItem, setCategoryItem] = useState(null)
    const [categoryItemDetail1, setCategoryItemDetail1] = useState(null)
    const [categoryItemDetail2, setCategoryItemDetail2] = useState(null)
    const [categoryItemDetail3, setCategoryItemDetail3] = useState(null)
    const [selectedActivity, setSelectedActivity] = useState(null)
    const [lastImageIndexRetrieved, setLastImageIndexRetrieved] = useState(null)
    const [numImagesConvertedFromHeic, setNumImagesConvertedFromHeic] = useState(0)
    const [numImagesUploaded, setNumImagesUploaded] = useState(0)
    const [numImagesFinishedUploading, setNumImagesFinishedUploading] = useState(0)
    const [openTagFriendsModal, setOpenTagFriendsModal] = useState(false)
    const [state, setState] = useState('')
    const [country, setCountry] = useState('')
    const [locationSearchResults, setLocationSearchResults] = useState([])
    const [photoListType, setPhotoListType] = useState("all")
    const [userImages, setUserImages] = useState([])
    const [allUserImages, setAllUserImages] = useState([])
    const [deletingTrip, setDeletingTrip] = useState(false)
    const [shouldRetrieveImages, setShouldRetrieveImages] = useState(false)
    const [retrievingImages, setRetrievingImages] = useState(false)
    const [openActivityModal, setOpenActivityModal] = useState(false)

    const fetchTrip = async () => {
        axios.get(`${getServerUrl()}/trip/${tripId}`, {
            headers: {Authorization: `Bearer ${await getBearerToken()}`}
        })
            .then(response => {
                setEditingTrip(false)
                setLocation(response.data.location)
                setName(response.data.name)
                setStartDate(response.data.startDate.split(" ")[0])
                setEndDate(response.data.endDate.split(" ")[0])
                setTripType(response.data.tripType)
                setParentTripName(response.data.parentTrip)
                setCategory(response.data.category || "")
                setCustomCategory("")
                setCategoryItem(response.data.categoryItem)
                setTaggedUsers(response.data.taggedUsers)
                setCategoryItemDetail1(response.data.categoryItemDetail1 ? response.data.categoryItemDetail1 : '')
                setCategoryItemDetail2(response.data.categoryItemDetail2 ? response.data.categoryItemDetail2 : '')
                setCategoryItemDetail3(response.data.categoryItemDetail3 ? response.data.categoryItemDetail3 : '')
                setTripId(tripId)
                setTripOwnerId(response.data.user.id)
                setState(response.data.state)
                setCountry(response.data.country)
                if (response.data.activities) {
                    setTripActivities(response.data.activities)
                }
                if (response.data.parentTrip) {
                    getParentTrip(response.data.parentTrip)
                }
            })
    }

    const fetchTripActivities = async () => {
        axios.get(`${getServerUrl()}/trip/${tripId}/activities`, {
            headers: {Authorization: `Bearer ${await getBearerToken()}`}
        })
            .then(response => {
                setTripActivities(response.data)
            })
    }

    const fetchParentTrips = async () => {
        axios.get(`${getServerUrl()}/parentTrips`, {
            headers: {Authorization: `Bearer ${await getBearerToken()}`}
        })
            .then(response => {
                setParentTrips(response.data)
            })
    }

    const fetchUserCategories = async () => {
        axios.get(`${getServerUrl()}/categories`, {
            headers: {Authorization: `Bearer ${await getBearerToken()}`}
        })
            .then(response => {
                setUserCategories(response.data)
            })
    }

    useEffect(() => {
        if (tripId && open) {
            fetchTrip()
            retrieveImagesInBatches(tripId, 0)
            fetchTripActivities()
            fetchParentTrips()
            fetchUserCategories()
            setTimeout(() => {

                const myDiv = document.getElementsByClassName("view-trip-div")?.[0]
                myDiv?.addEventListener('scroll', () => {
                    console.log('Scrolled modal');
                });
            }, 500)

        }
        if (!open) {
            setSelectedActivity(null)
            setLastImageIndexRetrieved(null)
        }
    }, [open])

    useEffect(() => {
        if (photoListType === 'user') {
            retrieveImagesInBatches(currentSelectedTripId, 0, true)
        }
    }, [photoListType, currentSelectedTripId])

    const searchForLocation = (selectedLocation) => {
        fetch(`https://api.mapbox.com/search/searchbox/v1/suggest?q=${selectedLocation}&language=en&limit=5&access_token=${accessToken}&session_token=${user.id}`)
            .then(response => response.json())
            .then(data => {
                setLocationSearchResults(data.suggestions)
            })
    }

    useEffect(() => {
        const searchLocations = setTimeout(() => {
            if (location) {
                searchForLocation(location)
            }
        }, 300)
        return () => clearTimeout(searchLocations)
    }, [location])

    const isScrollAtBottom = (element) => {
        return Math.abs(element.scrollHeight - element.clientHeight - element.scrollTop) <= 10;
    }


    const handleScroll = () => {
        const myDiv = document.querySelector('.view-trip-div');
        if (isScrollAtBottom(myDiv)) {
            if (!shouldRetrieveImages && !retrievingImages && (allImages?.length !== images.length && allImages?.length > 12)) {
                setShouldRetrieveImages(true)
            }
        }
    }

    useEffect(() => {
        const retrieveImages = setTimeout(() => {
            if (shouldRetrieveImages) {
                setShouldRetrieveImages(false)
                if ((allImages?.length !== images.length && allImages?.length > 12)) {
                    retrieveImagesInBatches(currentSelectedTripId, images.length, false, selectedActivityId, parentTripSelected)
                }
            }
        }, 250)
        return () => clearTimeout(retrieveImages)
    }, [allImages, images, shouldRetrieveImages])

    const getParentTrip = async parentTripName => {
        axios.get(`${getServerUrl()}/parentTrip`, {
            params: {
                parentTripName: parentTripName
            },
            headers: {Authorization: `Bearer ${await getBearerToken()}`}
        })
            .then(response => {
                setChildTrips(response.data.filter(childTrip => {
                    return (id && Number(id) !== user?.id) || childTrip?.user?.id === user?.id || childTrip?.taggedUsers?.filter(taggedUser => taggedUser?.user?.id === user?.id)?.length > 0
                }))
                const parentTripImageMap = {}
                response.data.forEach(trip => {
                    if (trip.id !== tripId) {
                        parentTripImageMap[trip.id] = []
                    }
                })
                setParentTripImages(parentTripImageMap)
            })
    }

    const retrieveImagesInBatches = async (selectedTripId, startIndex, loadUserImagesOnly = false, selectedActivityId = null, parentTripImages = false) => {
        setRetrievingImages(true)
        let url = `${getServerUrl()}/trip/${selectedTripId}${loadUserImagesOnly ? "/user/" + user?.id : ""}/images?loadCoverImage=true&shortenVideo=true&loadAsBatch=true&batchLoadIndex=${startIndex}`
        if (selectedActivityId) {
            url += `&activityId=${selectedActivityId}`
        }
        if (parentTripImages) {
            url += "&parentTripImages=true"
        }
        axios.get(url, {
            headers: {Authorization: `Bearer ${await getBearerToken()}`}
        })
            .then(response => {
                setRetrievingImages(false)
                if (startIndex === 0) {
                    if (loadUserImagesOnly) {
                        setAllUserImages(response.data)
                    } else {
                        setAllImages(response.data)
                    }
                }
                const newImages = response.data.slice(0, response.data.length > 12 ? 12 : response.data.length)
                if (startIndex === 0) {
                    if (loadUserImagesOnly) {
                        setUserImages(newImages)
                    } else {
                        setImages(newImages)
                    }
                } else {
                    if (loadUserImagesOnly) {
                        setUserImages(currentImages => {
                            const updatedCurrentImages = [...currentImages]
                            updatedCurrentImages.push(...newImages)
                            return updatedCurrentImages
                        })
                    } else {
                        setImages(currentImages => {
                            const updatedCurrentImages = [...currentImages]
                            updatedCurrentImages.push(...newImages)
                            return updatedCurrentImages
                        })
                    }
                }
            })
    }


    const retrieveImageForChildTrip = async (imageList, index) => {
        if (index < imageList.length) {
            axios.get(`${getServerUrl()}/image/${imageList[index].id}?loadCoverImage=true&shortenVideo=true`, {
                headers: {Authorization: `Bearer ${await getBearerToken()}`}
            })
                .then(response => {
                    imageList[index].image_location = response.data.image_location
                    imageList[index].video_location = response.data.video_location
                    imageList[index].videoCoverImage = response.data.videoCoverImage
                    setParentTripImages(currentParentTripImages => {
                        const updatedParentTripImages = JSON.parse(JSON.stringify(currentParentTripImages))
                        updatedParentTripImages[response.data.trip.id] = [...imageList]
                        return updatedParentTripImages
                    })
                    retrieveImageForChildTrip(imageList, index + 1)
                })
        }
    }


    const editImage = image => {
        if (openAddActivitiesModal) {
            const imageIds = [...imageIdsForActivity]
            if (imageIds.includes(image.id)) {
                setImageIdsForActivity(imageIds.filter(imageId => imageId !== image.id))
            } else {
                imageIds.push(image.id)
                setImageIdsForActivity(imageIds)
            }
        } else {
            setModalImage(image)
            setOpenImageModal(true)
        }
    }

    const deleteTrip = async () => {
        setDeletingTrip(true)
        axios.delete(`${getServerUrl()}/trip/${tripId}`, {
            headers: {
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
                "Access-Control-Allow-Headers": "Content-Type, Authorization, X-Requested-With",
                Authorization: `Bearer ${await getBearerToken()}`
            }
        })
            .then(() => {
                setDeletingTrip(false)
                setImages([]);
                onClose({id: tripId, location: location}, true)
            })
    }

    const getProfilePictureFromImages = () => {
        if (images?.length) {
            const profilePicId = images[0].trip.trip_profile_image
            const profilePicImage = images.find(image => image.id == profilePicId)
            const selectedImage = profilePicImage ? profilePicImage : images[0]
            return {id: selectedImage, image: selectedImage.image_location}
        }
    }

    const submitTrip = async () => {
        if (tripId) {
            axios.put(`${getServerUrl()}/trip/${currentSelectedTripId ? currentSelectedTripId : tripId}`, {
                name: name,
                location: location,
                startDate: startDate,
                endDate: endDate,
                tripType: tripType,
                parentTrip: parentTripName,
                category: category,
                categoryItem: categoryItem,
                categoryItemDetail1: categoryItemDetail1,
                categoryItemDetail2: categoryItemDetail2,
                categoryItemDetail3: categoryItemDetail3,
                country,
                state,
                customCategory
            }, {
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
                    "Access-Control-Allow-Headers": "Content-Type, Authorization, X-Requested-With",
                    Authorization: `Bearer ${await getBearerToken()}`
                }
            }).then(res => {
                res.data.trip_profile_image = getProfilePictureFromImages()?.image
                onTripUpdate(res.data);
            });
        } else {
            axios.post("${getServerUrl()}/trip/create", {
                name: name,
                location: location,
                startDate: startDate,
                endDate: endDate,
                tripType: tripType,
                parentTrip: parentTripName
            }, {
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
                    "Access-Control-Allow-Headers": "Content-Type, Authorization, X-Requested-With",
                    Authorization: `Bearer ${await getBearerToken()}`
                }
            }).then(res => {
                window.location.replace(`http://192.168.86.22:3000/trip/${res.data.id}`);
            });
        }
    }

    const confirmThenDeleteTrip = () => {

        confirmAlert({
            title: 'Confirm to submit',
            message: 'Are you sure to delete this trip?.',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => deleteTrip()
                },
                {
                    label: 'No',
                    //onClick: () => alert('Click No')
                }
            ]
        });
    }

    const submitImageActivities = async () => {
        axios.post(`${getServerUrl()}/trip/${currentSelectedTripId}/activities`, {
            activityId: activityIdForImages,
            imageIds: imageIdsForActivity
        }, {
            headers: {
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
                "Access-Control-Allow-Headers": "Content-Type, Authorization, X-Requested-With",
                Authorization: `Bearer ${await getBearerToken()}`
            }
        }).then(res => {
            const activity = images.filter(image => image?.activity?.id === activityIdForImages)[0]?.activity
            const updatedImages = images.map(image => {
                if (imageIdsForActivity.indexOf(image.id) !== -1) {
                    image.activity = activity
                }
                return image
            })
            setImages(updatedImages)
            setImageIdsForActivity([])
            setActivityIdForImages(null)
            setOpenAddActivitiesModal(false)
        });
    }

    const getSpotServerUrl = () => {
        return window.location.origin.includes("localhost") ? "http://localhost:8090" : "https://polar-tor-43011-08374123b3eb.herokuapp.com/http://mapapp-spot-env.eba-gfc2ni7c.us-east-1.elasticbeanstalk.com/"
    }

    const getScaleFactor = image => {
        if (image.naturalHeight > 3000 || image.naturalWidth > 3000) {
            return 3
        } else if (image.naturalHeight > 1500 || image.naturalWidth > 1500) {
            return 2
        }
        return 1
    }

    const submitImageToBackend = async (imgResult, reader, index, loadedImagesMap, loadedImages, newFiles, width, height, loadedUserImages) => {
        axios.post(`${getServerUrl()}/trip/${currentSelectedTripId}/images`, {
            fileType: imgResult.split(";")[0].replace("data:", "").replace("quicktime", "mp4"),
            image: imgResult.split(",")[1],
            description: `${index}`,
            width,
            height
        }, {
            headers: {
                Authorization: `Bearer ${await getBearerToken()}`
            }
        })
            .then(res => {
                console.log("spot instance server")
                const image = res.data
                if (!image.videoCoverImage) {
                    image.image_location = imgResult
                } else {
                    image.video_location = loadedImagesMap[image.description - 1]
                }
                loadedImages.unshift(image)
                setImages([...loadedImages])
                if (loadedUserImages) {
                    loadedUserImages.unshift(image)
                    setUserImages([...loadedUserImages])
                }
                setNumImagesFinishedUploading(number => number + 1)
                console.log(loadedImages)
            })
            .catch(e => {
                // console.log("regular server")
                setNumImagesFinishedUploading(number => number + 1)
                console.log(e)
                // submitImage(reader, index, loadedUserImages, loadedImages, newFiles, width, height, loadedUserImages, true)
            })
        if (index < newFiles.length) {
            reader.readAsDataURL(newFiles[index])
        }
    }

    const compressAndSubmitImage = async (reader, index, loadedImagesMap, loadedImages, newFiles, width, height, loadedUserImages) => {
        const img = new Image();
        img.onload = async () => {
            const iw = img.width;
            const ih = img.height;
            const scaleFactor = getScaleFactor(img)
            console.log("scaleFactor", scaleFactor)
            if (scaleFactor === 1) {
                submitImageToBackend(img.src, reader, index, loadedImagesMap, loadedImages, newFiles, width, height, loadedUserImages)
            } else {
                const c = document.createElement('canvas');
                const ctx = c.getContext('2d');
                console.log("height, width: ", iw, ih)
                c.width = iw / scaleFactor;
                c.height = ih / scaleFactor;
                ctx.drawImage(img, 0, 0, iw / scaleFactor, ih / scaleFactor);
                const scaledImg = new Image();
                scaledImg.onload = async () => {
                    // scaledImg is a scaled imageObject for upload/download
                    // For testing, just append it to the DOM
                    const imgResult = scaledImg.src
                    submitImageToBackend(imgResult, reader, index, loadedImagesMap, loadedImages, newFiles, width, height, loadedUserImages)
                    // document.body.appendChild(scaledImg);
                }
                scaledImg.src = c.toDataURL();
            }
        }
        img.src = reader.result
    }

    const submitImage = async (reader, index, loadedImagesMap, loadedImages, newFiles, width, height, loadedUserImages, useBackupServer) => {
        axios.post(`${getServerUrl()}/trip/${currentSelectedTripId}/images`, {
            fileType: reader.result.split(";")[0].replace("data:", "").replace("quicktime", "mp4"),
            image: reader.result.split(",")[1],
            description: `${index}`,
            width,
            height
        }, {
            headers: {
                Authorization: `Bearer ${await getBearerToken()}`
            }
        })
            .then(res => {
                console.log("spot instance server")
                const image = res.data
                if (!image.videoCoverImage) {
                    image.image_location = loadedImagesMap[image.description - 1]
                } else {
                    image.video_location = loadedImagesMap[image.description - 1]
                }
                loadedImages.unshift(image)
                setImages([...loadedImages])
                if (loadedUserImages) {
                    loadedUserImages.unshift(image)
                    setUserImages([...loadedUserImages])
                }
                setNumImagesFinishedUploading(number => number + 1)
                console.log(loadedImages)
            })
            .catch(e => {
                // console.log("regular server")
                setNumImagesFinishedUploading(number => number + 1)
                console.log(e)
                // submitImage(reader, index, loadedUserImages, loadedImages, newFiles, width, height, loadedUserImages, true)
            })
        if (index < newFiles.length) {
            reader.readAsDataURL(newFiles[index])
        }
    }

    const addImages = async e => {
        const files = Object.values(e.target.files)
        setNumImagesUploaded(files.length)
        const lastImageIndexRetrievedNum = lastImageIndexRetrieved ? lastImageIndexRetrieved : 0
        setLastImageIndexRetrieved(lastImageIndexRetrievedNum + files.length)
        let newFiles = await Promise.all(files.map(async file => {
            let updatedFile = file
            if (file.type.includes("heic")) {
                let blob = file //ev.target.files[0];
                let jpeg;
                try {
                    jpeg = await heicTo({
                        blob: blob,
                        toType: "image/jpeg",
                    })
                } catch (error) {
                    console.log(error)
                }
                // .then(function (resultBlob) {
                //     updatedFile = new File([resultBlob], "heic" + ".jpg", {
                //         type: "image/jpeg",
                //         lastModified: new Date().getTime()
                //     });
                //     return updatedFile
                // })
                // .catch(function (x) {
                //     console.log(x.code);
                //     console.log(x.message);
                // });
                setNumImagesConvertedFromHeic(currentNumber => {
                    const updatedNumber = currentNumber + 1;
                    return updatedNumber;
                })
                return jpeg;
            }
            setNumImagesConvertedFromHeic(currentNumber => {
                const updatedNumber = currentNumber + 1;
                return updatedNumber;
            })
            return updatedFile;
        }))
        newFiles = newFiles.filter(file => !file.type.includes("heic"))
        setAllImages([...allImages, ...newFiles.map(file => file.type)])
        if (photoListType === 'user') {
            setAllUserImages([...allUserImages, ...newFiles.map(file => file.type)])
        }
        const reader = new FileReader();
        const loadedImages = [...images]
        const loadedUserImages = photoListType === 'user' ? [...userImages] : null
        const loadedImagesMap = {}
        let index = 0
        reader.onloadend = function () {
            console.log("on load end")
            loadedImagesMap[`${index}`] = reader.result
            index += 1
            console.log("uploading video")
            console.log(reader.result.split(';'))
            if (reader.result.split(";")[0].includes("mp4") || reader.result.split(";")[0].includes("quicktime")) {
                const video = document.createElement('video');
                // place a listener on it
                video.addEventListener("loadedmetadata", function () {
                    // retrieve dimensions
                    const height = this.videoHeight;
                    const width = this.videoWidth;
                    console.log("videoDuration: " +this.duration)
                    if (this.duration > 10) {
                        confirmAlert({
                            title: 'Exceeded Max Video Size',
                            message: 'Unfortunately for this beta version, we are limiting video uploads to 10 seconds due to server limitations (AKA I am too cheap to pay for a nice server). Please crop video and try again.',
                            buttons: [
                                {
                                    label: 'Close'
                                }
                            ]
                        });
                    } else {
                        submitImage(reader, index, loadedImagesMap, loadedImages, newFiles, width, height, loadedUserImages)
                    }
                }, false);
                video.src = reader.result;
            } else {
                console.log("uploading photo")
                compressAndSubmitImage(reader, index, loadedImagesMap, loadedImages, newFiles, null, null, loadedUserImages)
            }


            // start download meta-datas
        }
        await reader.readAsDataURL(newFiles[0])
        e.target.value = null
    }

    const updateTripActivities = updatedImage => {
        const updatedTripActivities = [...tripActivities]
        if (updatedImage?.activity?.id && !tripActivities.map(activity => activity.id).includes(updatedImage?.activity?.id)) {
            updatedTripActivities.push(updatedImage.activity)
            setTripActivities(updatedTripActivities)
            setOpenAddActivitiesModal(true)
            setActivityIdForImages(updatedImage.activity.id)
            setImageIdsForActivity([updatedImage?.id])
        }
    }


    const closeImageModal = (updatedImage, action) => {
        setOpenImageModal(false);
        setModalImage(null)
        if (action === "update") {
            const updatedImages = images.map(image => {
                if (image.id === updatedImage.id) {
                    image = updatedImage
                }
                if (updatedImage.isProfilePicture) {
                    image.trip.trip_profile_image = updatedImage.id
                }
                return image;
            })
            setImages(updatedImages)
            updateTripActivities(updatedImage)

        } else if (action === "delete") {
            const updatedImages = images.filter(image => image.id !== updatedImage.id)
            setImages(updatedImages)
        }
    }
    const displayImages = imageList => {
        return imageList.filter(image => {
            return (image.image_location || image.video_location) && (!selectedActivity || image?.activity?.location === selectedActivity)
        }).map((image, index) => {
            return <ImageBox
                imageFile={image}
                onClick={editImage}
                imageIdsForNewActivity={imageIdsForActivity}
                key={image.id}
                showVideoCoverImage={true}
            />
        })
    }

    const displayParentTripImages = () => {
        const additionalTripImages = []
        Object.values(parentTripImages).forEach(tripImages => {
            if (tripImages?.length > 0) {
                additionalTripImages.push(...tripImages)
            }
        })
        console.log(additionalTripImages)
        const allTripImages = images.concat(additionalTripImages)
        return allTripImages.filter(image => {
            return (image.image_location || image.video_location) && (!selectedActivity || image.trip.location === selectedActivity)
        }).map(image => {
            return <ImageBox imageFile={image} onClick={editImage} imageIdsForNewActivity={imageIdsForActivity}
                             key={image.id} showVideoCoverImage={true}/>
        })

    }

    const loadChildTripInfo = trip => {
        setPhotoListType('all')
        setParentTripSelected(false)
        setSelectedActivity(null)
        setLocation(trip.location)
        setName(trip.name)
        setStartDate(trip.startDate)
        setEndDate(trip.endDate)
        setTripType(trip.tripType)
        setParentTripName(trip.parentTrip)
        setSelectedChildTrip(trip.id)
        setTripId(trip.id)
        setState(trip.state)
        setCountry(trip.country)
        if (trip.activities) {
            setTripActivities([...trip.activities])
        }
        setImages([])
        setAllImages([])
        setAllUserImages([])
        retrieveImagesInBatches(trip.id, 0, false, null, false)
    }

    const filterTripsForMarkerEvent = (tripLocation, locationMarkerObj, locations) => {
        setLocationsClickedStatus(obj => {
            const currentTripLocationsObj = {...obj}
            const updatedTripLocationsObj = {}
            Object.keys(currentTripLocationsObj).forEach(location => {
                if (tripLocation !== location)
                    updatedTripLocationsObj[location] = false
            })
            const selectedTripLocationStatus = !currentTripLocationsObj[tripLocation]
            updatedTripLocationsObj[tripLocation] = selectedTripLocationStatus
            setSelectedActivity(selectedTripLocationStatus ? tripLocation : null)
            const selectedActivityId = tripActivities.find(tripActivity => tripActivity.location === tripLocation)?.id
            setImages([])
            setAllImages([])
            setAllUserImages([])
            if (!parentTripSelected) {
                if (selectedTripLocationStatus) {
                    retrieveImagesInBatches(currentSelectedTripId, 0, false, selectedActivityId)
                } else {
                    retrieveImagesInBatches(currentSelectedTripId, 0, false, null, false)
                }
            }

            return updatedTripLocationsObj
        })
        if (parentTripSelected) {
            setParentTripSelected(false)
            const trip = childTrips.find(childTrip => childTrip.location === tripLocation)
            loadChildTripInfo(trip)

        }
        // locations={locationList && !parentTripSelected ? locationList : childTrips.map(trip => trip.location)}
        //     locations.forEach(markerLocation => {
        //         const marker = locationMarkerObj[markerLocation]
        //         if (marker) {
        //             marker.remove()
        //         }
        //     })
    }


    const displayParentTripOptions = parentTrips.map(tripName => {
        return <option value={tripName}>{tripName}</option>
    })
    const getChildrenTripLinks = () => {
        return childTrips.map(trip => {
            return (
                <a onClick={() => {
                    loadChildTripInfo(trip)
                }}>{trip.name}</a>
            )
        })
    }

    const displayTripImages = (childTripId, parentTripSelectedBoolean, showUserImages = false) => {
        if (parentTripSelected) {
            return displayParentTripImages()
        } else {
            if (showUserImages) {
                return displayImages(userImages)
            } else {
                return displayImages(images)
            }
        }
    }

    const getLatestTripWithProfilePictureWhenClosing = () => {
        const profilePic = getProfilePictureFromImages()
        return {id: currentSelectedTripId, profilePicture: profilePic.image, profilePictureId: profilePic.id}
    }
    let currentSelectedLocation = location
    Object.keys(locationsClickedStatus).forEach(clickedLocation => {
        if (locationsClickedStatus[clickedLocation]) {
            currentSelectedLocation = clickedLocation
        }
    })
    const locationAlreadyInActivityList = {}

    // const currentSelectedTripId = childTrips ? childTrips?.find(childTrip => childTrip.location === currentSelectedLocation)?.id : tripId

    // let activityImageList = (currentSelectedTripId === tripId || !currentSelectedTripId) ? images : parentTripImages[currentSelectedTripId]
    // const locationActivityList = activityImageList?.map(image => image?.activity?.location)?.filter(activityLocation => {
    //     if (!locationAlreadyInActivityList[activityLocation]) {
    //         locationAlreadyInActivityList[activityLocation] = true
    //         return true
    //     }
    //     return false
    // })

    const locationActivityList = tripActivities.map(activity => activity.location)
    const selectedActivityId = selectedActivity ? tripActivities?.find(activity => activity?.location === selectedActivity)?.id : null
    const selectedActivityName = selectedActivity ? tripActivities?.find(activity => activity?.location === selectedActivity)?.name : ""

    const locationList = locationActivityList?.length > 0 ? locationActivityList : [location]

    // if (deletingTrip) {
    //
    // return (
    //     <ReactModal isOpen={open} className="view-trip-modal">
    //     </ReactModal>
    // )

    // }

    const allPhotosBelongToUser = allImages.filter(image => image.user?.id === user?.id).length === allImages.length
    const allPhotosDontBelongToUser = allImages.filter(image => image.user?.id !== user?.id).length === allImages.length

    const categoryList = ["", ...userCategories.map(category => category.name), "National Park", "NFL", "MLB", "Custom"]

    if (currentSelectedTripId) {

        return (
            <ReactModal isOpen={open} className="view-trip-modal">
                {deletingTrip && (
                    <div className="delete-trip-container">
                        <CircularProgress size={100}/>
                        <h2>Deleting Trip...</h2>
                    </div>
                )}
                {!deletingTrip && (
                    <div className="view-trip-div" onScroll={() => handleScroll()}>
                        {openAddActivitiesModal && <div id="add-activities-popup">
                            Add activity to other images: {imageIdsForActivity.length} selected <br/>
                            <button onClick={() => {
                                setOpenAddActivitiesModal(false)
                                setImageIdsForActivity([])
                                setParentTripSelected(false)
                            }}>Cancel
                            </button>
                            <button onClick={submitImageActivities}>Done</button>
                        </div>}
                        <div id="view-trip-header">
                            <div id="view-trip-header-title">
                                <h2>{parentTripSelected ? parentTripName : name}</h2>
                                {(startDate && endDate) && (
                                    <h4 id="view-trip-location">{location} — <span>{formatDate(startDate)} - {formatDate(endDate)}</span>
                                    </h4>
                                )}
                                {
                                    parentTripSelected ? <div id="children-trip-links">{getChildrenTripLinks()}</div> :
                                        parentTripName ? <a type="text" onClick={() => {
                                            setParentTripSelected(true)
                                            retrieveImagesInBatches(currentSelectedTripId, 0, false, null, true)
                                            setSelectedActivity(null)

                                        }}>{parentTripName}</a> : null
                                }
                            </div>
                            {(!editingTrip && user?.id === tripOwnerId) &&
                            <button id="edit-trip-button" onClick={() => setEditingTrip(true)}>
                                Edit Trip
                            </button>}
                            {(!editingTrip && (user?.id === tripOwnerId || taggedUsers?.filter(taggedUser => taggedUser.user.id === user?.id)?.length > 0)) && (
                                <label className="file-upload-button" id="upload-images-button">
                                    Upload Photos <input
                                    type="file"
                                    accept="image/*"
                                    style={{display: "none"}}
                                    id="file-upload"
                                    onChange={addImages}
                                    multiple
                                />
                                </label>
                            )}
                            {(!editingTrip && (user?.id === tripOwnerId || taggedUsers?.filter(taggedUser => taggedUser.user.id === user?.id)?.length > 0)) && (
                                <label className="file-upload-button" id="upload-video-button">
                                    Upload Videos <input
                                    type="file"
                                    accept="video/mp4"
                                    style={{display: "none"}}
                                    id="file-upload"
                                    onChange={addImages}
                                />
                                </label>
                            )}
                            {(!editingTrip && user?.id === tripOwnerId) && (
                                <button onClick={() => setOpenTagFriendsModal(true)} id="tag-friend-button">Tag
                                    friends</button>
                            )}
                            {(!parentTripSelected && editingTrip) &&
                            <button id="submit-trip-button" onClick={submitTrip}>
                                {tripId ? "Update Trip!" : "Create trip!"}
                            </button>}
                            <button id="go-home-button" onClick={() => {
                                setImages([]);
                                setTripId(null)
                                if (images?.length) {
                                    onClose(getLatestTripWithProfilePictureWhenClosing(), false)
                                } else {
                                    onClose()
                                }
                                setParentTripSelected(false)
                                setEditingTrip(false)
                            }}>
                                Close
                            </button>

                            {(!parentTripSelected && editingTrip) &&
                            <button id='delete-trip-button' onClick={() => confirmThenDeleteTrip()}>
                                Delete Trip
                            </button>}
                        </div>
                        <div style={{width: "100%"}}>
                            <AllTripsMap
                                initialZoomLevel={10}
                                includeZoom={true}
                                locations={locationList && !parentTripSelected ? locationList : childTrips.map(trip => trip.location)}
                                onMarkerEvent={filterTripsForMarkerEvent}
                                locationsClickedStatus={locationsClickedStatus}
                                location={location}
                                viewingMultipleTrips={parentTripSelected}
                            />
                        </div>
                        {(!parentTripSelected && editingTrip) && <div className="createTrip">
                            <div id="tripInfo">
                                <div className="tripTypeDiv">
                                    <div className="parent-trip-input">
                                        <p>Trip Name</p>
                                        <Autocomplete
                                            id="free-solo-demo"
                                            freeSolo
                                            filterOptions={(x) => x}
                                            options={[]}
                                            renderInput={(params) => <TextField {...params}
                                                                                label="Enter trip's name"/>}
                                            onInputChange={(event, newInputValue) => {
                                                setName(newInputValue)
                                            }}
                                            inputValue={name}
                                        />
                                    </div>
                                </div>
                                <div className="tripTypeDiv">
                                    <div className="parent-trip-input">
                                        <p>Location</p>
                                        <Autocomplete
                                            id="free-solo-demo"
                                            freeSolo
                                            filterOptions={(x) => x}
                                            options={locationSearchResults?.map(locationSearchResult => `${locationSearchResult.name} - ${locationSearchResult.place_formatted}`)}
                                            renderInput={(params) => <TextField {...params}
                                                                                label="Enter trip's main location"/>}
                                            onInputChange={(event, newInputValue) => {
                                                setLocation(newInputValue)
                                                locationSearchResults?.forEach(locationSearchResult => {
                                                    if (newInputValue.includes(" - ") && locationSearchResult.place_formatted === newInputValue.split(" - ")[1]) {
                                                        setCountry(locationSearchResult?.context?.country?.name || "United States")
                                                        setState(locationSearchResult?.context?.region?.name || "")
                                                    }
                                                })
                                            }}
                                            inputValue={location}
                                        />
                                    </div>
                                </div>
                                <div className="tripTypeDiv">
                                    <div className="parent-trip-input">
                                        <p>State</p>
                                        <Autocomplete
                                            id="free-solo-demo"
                                            freeSolo
                                            filterOptions={(x) => x}
                                            options={[]}
                                            renderInput={(params) => <TextField {...params}
                                                                                label="Enter state visited"/>}
                                            onInputChange={(event, newInputValue) => {
                                                setState(newInputValue)
                                            }}
                                            inputValue={state}
                                            // style={{width: 200}}
                                        />
                                    </div>
                                </div>
                                <div className="tripTypeDiv">
                                    <div className="parent-trip-input">
                                        <p>Country</p>
                                        <Autocomplete
                                            id="free-solo-demo"
                                            freeSolo
                                            filterOptions={(x) => x}
                                            options={[]}
                                            renderInput={(params) => <TextField {...params}
                                                                                label="Enter country visited"/>}
                                            onInputChange={(event, newInputValue) => {
                                                setCountry(newInputValue)
                                            }}
                                            inputValue={country}
                                            // style={{width: 200}}
                                        />
                                    </div>
                                </div>
                                <div className="trip-info-input">
                                    <label htmlFor="startDate">
                                        Start Date
                                        <input className="trip-date-input" id="startDate" value={startDate}
                                               onChange={e => {
                                                   setStartDate(e.target.value)
                                                   setEndDate(e.target.value)

                                               }}
                                               type="date"/>
                                    </label>
                                </div>
                                <div className="trip-info-input">
                                    <label htmlFor="endDate">
                                        End Date
                                        <input className="trip-date-input" id="endDate" value={endDate}
                                               onChange={e => setEndDate(e.target.value)}
                                               type="date"/>
                                    </label>
                                </div>
                                <div className="category-div-container">
                                    <Box display="flex" alignItems="center" gap={2} className="category-dropdown">
                                        <span>Category</span>
                                        <FormControl size="small" sx={{minWidth: 200}}>
                                            <Select
                                                value={category}
                                                onChange={e => setCategory(e.target.value)}
                                                displayEmpty
                                                inputProps={{'aria-label': 'Category'}}
                                                style={{background: "white"}}
                                            >
                                                {categoryList.map(categoryItem => (
                                                    <MenuItem value={categoryItem} disabled={categoryItem === ""}
                                                              key="categoryItem">
                                                        {categoryItem === "" ? "Select a trip category" : categoryItem}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Box>
                                    {category === 'Custom' && (
                                        <div className="tripTypeDiv">
                                            <div className="parent-trip-input">
                                                <p>Category Name</p>
                                                <Autocomplete
                                                    id="free-solo-demo"
                                                    freeSolo
                                                    filterOptions={(x) => x}
                                                    options={[]}
                                                    renderInput={(params) => <TextField {...params}
                                                                                        label="Enter custom category"/>}
                                                    onInputChange={(event, newInputValue) => {
                                                        setCustomCategory(newInputValue)
                                                    }}
                                                    inputValue={customCategory}
                                                    style={{width: 200}}
                                                />
                                            </div>
                                        </div>
                                    )}
                                    {category === "National Park" && (
                                        <label htlmFor="categoryItem">
                                            National Park Visited
                                            <select className="trip-select-dropdown" id="categoryItem"
                                                    value={categoryItem}
                                                    onChange={e => setCategoryItem(e.target.value)}>
                                                {nationalParks.map(nationalPark => {
                                                    return <option>{nationalPark.name}</option>
                                                })}
                                            </select>
                                        </label>
                                    )}
                                    {category === "NFL" && (
                                        <label htlmFor="categoryItem">
                                            NFL Team Visited
                                            <select className="trip-select-dropdown" id="categoryItem"
                                                    value={categoryItem}
                                                    onChange={e => setCategoryItem(e.target.value)}>
                                                {Object.keys(nflTeams).sort().map(team => {
                                                    return <option>{team}</option>
                                                })}
                                            </select>
                                        </label>
                                    )}
                                    {category === "NFL" && (
                                        <label htlmFor="categoryItemDetail1">
                                            Away Team
                                            <select className="trip-select-dropdown" id="categoryItemDetail1"
                                                    value={categoryItemDetail1}
                                                    onChange={e => setCategoryItemDetail1(e.target.value)}>
                                                {Object.keys(nflTeams).sort().map(team => {
                                                    return <option>{team}</option>
                                                })}
                                            </select>
                                        </label>
                                    )}
                                    {category === "NFL" && (
                                        <label htlmFor="categoryItemDetail2">
                                            Home Team Score
                                            <input className="trip-date-input" id="categoryItemDetail2"
                                                   value={categoryItemDetail2}
                                                   onChange={e => setCategoryItemDetail2(e.target.value)}/>
                                        </label>
                                    )}
                                    {category === "NFL" && (
                                        <label htlmFor="categoryItemDetail3">
                                            Away Team Score
                                            <input className="trip-date-input" id="categoryItemDetail3"
                                                   value={categoryItemDetail3}
                                                   onChange={e => setCategoryItemDetail3(e.target.value)}/>

                                        </label>
                                    )}
                                    {category === "MLB" && (
                                        <label htlmFor="categoryItem">
                                            Team Visited
                                            <select className="trip-select-dropdown" id="categoryItem"
                                                    value={categoryItem}
                                                    onChange={e => setCategoryItem(e.target.value)}>
                                                {["", ...Object.keys(mlbTeams).sort()].map(team => {
                                                    return <option
                                                        value={convertCamelCaseToSpacedWords(team)}>{team === "" ? "Select a Team" : convertCamelCaseToSpacedWords(team)}</option>
                                                })}
                                            </select>
                                        </label>
                                    )}
                                    {category === "MLB" && (
                                        <label htlmFor="categoryItemDetail1">
                                            Away Team
                                            <select className="trip-select-dropdown" id="categoryItemDetail1"
                                                    value={categoryItemDetail1}
                                                    onChange={e => setCategoryItemDetail1(e.target.value)}>
                                                {["", ...Object.keys(mlbTeams).sort()].map(team => {
                                                    return <option
                                                        value={convertCamelCaseToSpacedWords(team)}>{team === "" ? "Select a Team" : convertCamelCaseToSpacedWords(team)}</option>
                                                })}
                                            </select>
                                        </label>
                                    )}
                                    {category === "MLB" && (
                                        <label htlmFor="categoryItemDetail2">
                                            Home Team Score
                                            <input className="trip-date-input" id="categoryItemDetail2"
                                                   value={categoryItemDetail2}
                                                   onChange={e => setCategoryItemDetail2(e.target.value)}/>
                                        </label>
                                    )}
                                    {category === "MLB" && (
                                        <label htlmFor="categoryItemDetail3">
                                            Away Team Score
                                            <input className="trip-date-input" id="categoryItemDetail3"
                                                   value={categoryItemDetail3}
                                                   onChange={e => setCategoryItemDetail3(e.target.value)}/>

                                        </label>
                                    )}
                                </div>
                                <div className="tripTypeDiv">
                                    <label htlmFor="parentTripCheckbox">
                                        Trip type
                                        <select className="trip-select-dropdown" id="parentTripSelect" value={tripType}
                                                onChange={e => setTripType(e.target.value)}>
                                            <option value="single">Singe Location Trip</option>
                                            <option value="multiple">Multiple Location Trip</option>
                                        </select>
                                    </label>
                                    {tripType === 'parentTrip' && (<label htmlFor="parentTripInput">
                                        Parent Trip Name
                                        <input id='parentTripInput' value={parentTripName}
                                               onChange={e => setParentTripName(e.target.value)}/>
                                    </label>)}
                                    {tripType === 'multiple' && (
                                        <div className="parent-trip-input">
                                            Parent Trip Name
                                            <Autocomplete
                                                id="free-solo-demo"
                                                freeSolo
                                                options={parentTrips?.filter(trip => !!trip)}
                                                renderInput={(params) => <TextField {...params}
                                                                                    label="Type parent trip name, or choose from existing..."/>}
                                                onInputChange={(event, newInputValue) => {
                                                    setParentTripName(newInputValue)
                                                }}
                                                inputValue={parentTripName}
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                        }
                        {((user?.id === tripOwnerId || taggedUsers?.filter(taggedUser => taggedUser.user.id === user?.id)?.length > 0)) && (
                            <div className="edit-trip-actions-buttons">
                                {tripId && (
                                    <div>
                                        <label className="file-upload-button">
                                            Upload Photos <input
                                            type="file"
                                            accept="image/*"
                                            style={{display: "none"}}
                                            id="file-upload"
                                            onChange={addImages}
                                            multiple
                                        />
                                        </label>
                                    </div>
                                )}
                                {tripId && (
                                    <div>
                                        <label className="file-upload-button">
                                            Upload Videos <input
                                            type="file"
                                            accept="video/mp4"
                                            style={{display: "none"}}
                                            id="file-upload"
                                            onChange={addImages}
                                        />
                                        </label>
                                    </div>
                                )}
                                {tripId && (
                                    <div className="trip-info-input">
                                        <button onClick={() => setOpenTagFriendsModal(true)}>Tag friends</button>
                                    </div>
                                )}
                                {tripId && (
                                    <div className="trip-info-input">
                                        <button onClick={() => setOpenActivityModal(true)}>Add Activity</button>
                                    </div>
                                )}
                            </div>
                        )}

                        {(tripId && selectedActivity) && (
                            <h1 style={{textAlign: "center"}}>{selectedActivityName}</h1>
                        )}
                        {(!id && tripId && taggedUsers.length > 0 && !allPhotosBelongToUser && !allPhotosDontBelongToUser) && (
                            <div id="view-trip-photo-selection-container">
                                <ToggleButtonGroup
                                    value={photoListType}
                                    exclusive
                                    onChange={(event, selected) => setPhotoListType(selected)}
                                    aria-label="text alignment"
                                >
                                    <ToggleButton value='all' aria-label="left aligned">
                                        All Photos
                                    </ToggleButton>
                                    <ToggleButton value='user' aria-label="left aligned">
                                        Your photos
                                    </ToggleButton>
                                </ToggleButtonGroup>
                            </div>
                        )}
                        {photoListType === 'all' && (
                            <>
                                {tripId && (<div id="view-trip-images">
                                    {displayTripImages(selectedChildTrip, parentTripSelected)}
                                </div>)}
                                {shouldRetrieveImages && (
                                    <div className="circular-progress-images">
                                        <CircularProgress size={20}/>
                                    </div>
                                )}
                            </>
                        )}
                        {photoListType === 'user' && (
                            <>
                                {tripId && (<div id="view-trip-images">
                                    {displayTripImages(selectedChildTrip, parentTripSelected, true)}
                                </div>)}
                                {tripId && (<div className="load-more-trip-images">
                                    {(allUserImages?.length !== userImages.length && allUserImages?.length > 12) && (
                                        <button
                                            onClick={() => retrieveImagesInBatches(currentSelectedTripId, userImages.length, !selectedActivityId && !parentTripSelected, selectedActivityId, parentTripSelected)}>Load
                                            More</button>
                                    )}
                                </div>)}
                            </>
                        )}


                        <TagFriendsModal tripId={tripId} open={openTagFriendsModal}
                                         onClose={() => setOpenTagFriendsModal(false)} tripOwnerId={tripOwnerId}/>
                        <ImageModal modalImage={modalImage} open={openImageModal} onClose={closeImageModal}
                                    tripActivities
                                    imageActivity={modalImage?.activity} activities={tripActivities}
                                    editingTrip={editingTrip}/>
                        <ImageLoaderModal numImagesConvertedFromHeic={numImagesConvertedFromHeic}
                                          numImagesFinishedUploading={numImagesFinishedUploading}
                                          numImagesUploaded={numImagesUploaded}
                                          open={numImagesUploaded !== 0 && numImagesFinishedUploading !== numImagesUploaded}
                                          onUploadFinish={() => {
                                              setNumImagesFinishedUploading(0)
                                              setNumImagesConvertedFromHeic(0)
                                              setNumImagesUploaded(0)
                                          }}
                        />
                        <CreateActivity open={openActivityModal}
                                        tripId={currentSelectedTripId}
                                        tripLocation={location}
                                        tripCountry={country}
                                        tripState={state}
                                        onClose={activity => {
                                            setOpenActivityModal(false)
                                            const updatedTripActivities = [...tripActivities]
                                            if (activity?.id) {
                                                updatedTripActivities.push(activity)
                                                setTripActivities(updatedTripActivities)
                                                setOpenAddActivitiesModal(true)
                                                setActivityIdForImages(activity.id)
                                            }
                                        }}
                        />

                    </div>
                )}

            </ReactModal>
        )
    }
    return null
}

export default ViewTrip;
